export const formatDescriptionHtml = (htmlString: string) => {
  return htmlString
    .replaceAll('<table>', '<div style="overflow-x:auto"><table>')
    .replaceAll('</table>', '</table></div>');
};
